const i18n = JSON.parse(document.getElementById('FebellaI18n')?.textContent || '{}');
document.querySelectorAll('[data-language-selector]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
// Native forms remain functional without JavaScript.
document.querySelectorAll('[data-sort]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
const productQuery = new URLSearchParams(location.search).get('product');
const message = document.querySelector('#ContactMessage');
if (productQuery && message && !message.value) message.value = `${i18n.inquiry} ${productQuery}.`;
const menus = '.mobile-menu[open], .needs-menu[open], .language-picker[open]';
document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll(menus).forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); }); });
document.addEventListener('click', event => document.querySelectorAll(menus).forEach(menu => { if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false; }));
function initDiscovery(root = document) {
  root.querySelectorAll('[data-product-discovery]').forEach(section => {
    const filters = section.querySelector('.discovery-filters');
    if (!filters || filters.dataset.ready) return;
    filters.dataset.ready = 'true'; filters.hidden = false;
    const buttons = [...filters.querySelectorAll('[data-product-filter]')];
    const items = [...section.querySelectorAll('[data-discovery-item]')];
    buttons.forEach(button => button.addEventListener('click', () => {
      const key = button.dataset.productFilter;
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      let count = 0;
      items.forEach(item => { item.hidden = !item.dataset.categories.split(' ').includes(key); if (!item.hidden) count++; });
      section.querySelector('[role="status"]').textContent = `${button.textContent.trim()}: ${count} ${i18n.products}`;
    }));
  });
}
initDiscovery();
const initializedAccordions = new WeakSet();
const accordionReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
function initAccordions(root = document) {
  root.querySelectorAll('.product-accordions details').forEach(details => {
    const summary = details.querySelector('summary');
    if (!summary || initializedAccordions.has(details)) return;
    initializedAccordions.add(details);
    let animation = null;
    let targetOpen = details.open;
    summary.addEventListener('click', event => {
      if (accordionReducedMotion.matches || typeof details.animate !== 'function') {
        if (animation) animation.finish();
        return;
      }
      event.preventDefault();
      targetOpen = animation ? !targetOpen : !details.open;
      const startHeight = details.getBoundingClientRect().height;
      if (animation) {
        animation.onfinish = null;
        animation.cancel();
      }
      details.style.height = '';
      details.open = true;
      const style = getComputedStyle(details);
      const closedHeight = summary.getBoundingClientRect().height
        + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)
        + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      const endHeight = targetOpen ? details.getBoundingClientRect().height : closedHeight;
      details.style.height = `${startHeight}px`;
      details.style.overflow = 'hidden';
      animation = details.animate(
        [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
        { duration: targetOpen ? 260 : 200, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      animation.onfinish = () => {
        details.open = targetOpen;
        details.style.height = '';
        details.style.overflow = '';
        animation = null;
      };
    });
  });
}
initAccordions();
document.addEventListener('shopify:section:load', event => { initDiscovery(event.target); initAccordions(event.target); });
const policyTitles = {'privacy-policy':i18n.privacy,'contact-information':i18n.contact,'refund-policy':i18n.refund,'terms-of-service':i18n.terms,'shipping-policy':i18n.shipping,'legal-notice':i18n.legal};
const policyHeading = document.querySelector('.shopify-policy__title h1');
if (policyHeading && policyTitles[location.pathname.split('/').pop()]) {policyHeading.textContent = policyTitles[location.pathname.split('/').pop()];}

// Keep the native variant ID, price, availability and quantity limit in sync.
const initializedVariantSelects = new WeakSet();
function initProductVariants(root = document) {
  root.querySelectorAll('[data-product-variant]').forEach(select => {
    if (initializedVariantSelects.has(select) || !select.form) return;
    initializedVariantSelects.add(select);
    const quantity = select.form.querySelector('[name="quantity"]');
    const button = select.form.querySelector('[name="add"]');
    const price = select.closest('.detail-copy')?.querySelector('[data-price]');
    const sync = () => {
      const option = select.selectedOptions[0];
      const selected = Boolean(option?.value);
      const available = selected && !option.disabled && option.dataset.available !== 'false';
      if (button) {
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel
          : !selected && button.dataset.productAvailable === 'true'
            ? button.dataset.selectLabel : button.dataset.unavailableLabel;
      }
      if (selected && price && option.dataset.price) price.textContent = option.dataset.price;
      if (quantity) {
        const stock = available ? Number(option.dataset.stock) : 0;
        if (stock > 0) quantity.max = String(stock);
        else quantity.removeAttribute('max');
        if (stock > 0 && Number(quantity.value) > stock) quantity.value = String(stock);
      }
    };
    select.addEventListener('change', sync);
    sync();
  });
}
initProductVariants();
document.addEventListener('shopify:section:load', event => initProductVariants(event.target));
